/**
 * AdminHeader
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Card } from 'react-bootstrap';

function AdminHeader(props) {
  const { count, title, control, intro } = props;
  return (
    <Card.Header className="border-0">
      <div className="d-flex align-items-baseline input-height">
        <h3 className="flex-grow-1 mt-2">
          <FormattedMessage {...title} />
          {count > 1 && <span>{` (${count})`}</span>}
        </h3>
        {control}
      </div>
      {intro && <div className="form-text mb-3"><FormattedMessage {...intro} /></div>}
    </Card.Header>
  );
}

AdminHeader.propTypes = {
  count: PropTypes.number,
  title: PropTypes.object,
  intro: PropTypes.object,
  control: PropTypes.node,
};

export default AdminHeader;
